import '../Core/scripts/sitewide.js';
import './homepage.scss';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel';
import '../Core/scripts/shortlist';
import React from "react";
import ReactDOM from "react-dom";

import {setupFooterDropdowns} from '../Core/scripts/utilities';

$(document).ready(function(){
    const FranchiseFinder = React.lazy(() => import("../../react/components/franchise_finder"))

    if (document.querySelector(".franchise-finder-container")) {
        ReactDOM.render(
            <div>
                <React.Suspense fallback={<div></div>}>
                    <FranchiseFinder />
                </React.Suspense>
            </div>,
            document.querySelector(".franchise-finder-container")
        );
    }

    $(".homepage-company-carousel").owlCarousel({
        
        loop: true,
        nav: true,
        autoplay: true,
        lazyLoad: true,
        autoplayTimeout: 4000,
        autoplayHover: true,
        animateOut: 'fadeOut',
        navText: [
            '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
            '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
        ],
        responsive: {
            0: {
                items: 3.4,
                margin: 13,
                slideBy: 3
            },
            600: {
                items: 4.2,
                margin: 20,
                slideBy: 4
            },
            767: {
                items: 4,
                margin: 20,
                slideBy: 4
            },
            992 : {
                items: 6,
                margin: 25,
                slideBy: 6
            }
        }
    });

    let lazyLoadContainer = document.querySelector('.homepage-lazy');
    $.ajax({
        
        type: "GET",
        url: '/site/homepage-lower',
        success: function (result) {
            lazyLoadContainer.classList.add('loaded');
            setTimeout(function() {
                lazyLoadContainer.innerHTML = result;
                afterLazyLoad();
                lazyLoadContainer.classList.add('displayed');
            },1000);
            
        }
    });
});

  //Homepage
  function afterLazyLoad()
  {
      //Initialise category carousel
      $(".homepage-category-carousel").owlCarousel({
          loop: true,
          nav: true,
          autoplay: false,
          autoplayTimeout: 3000,
          autoplayHover: true,
          animateOut: 'fadeOut',
          navText: [
              '<i class="fa fa-chevron-left" aria-hidden="true"></i>',
              '<i class="fa fa-chevron-right" aria-hidden="true"></i>'
          ],
          responsive: {
              0: {
                  items: 2.2,
                  margin: 20,
                  slideBy: 2
              },
              500: {
                  items: 3,
                  margin: 20,
                  slideBy: 3
              },
              700: {
                  items: 4,
                  margin: 25,
                  slideBy: 4
              }
          }
      });

      //Setup form listener
      document.querySelector('#franchise-locator-form').addEventListener('submit', function(event) {
          event.preventDefault();
          var form = event.target;

          var location = document.querySelector('#location-select').value;
          var industry = document.querySelector('#industry-select').value;

          dataLayer.push(
              {
                  'event': 'myTrackEvent', 
                  'eventCategory': 'Footer', 
                  'eventAction': 'Submit Local Form', 
                  'eventLabel': location + ',' + industry
              }
          );

          window.location.href = '/local/'+ location +'?where=&industry=' + industry;
      })

      //Setup business advice accordion triggers
      var businessAccordianTriggers = document.querySelectorAll('.business-toggle');
      
      setupFooterDropdowns();
      for (var x = 0; x < businessAccordianTriggers.length; x++)
      {
          businessAccordianTriggers[x].addEventListener('click', function(event) {
              event.target.parentNode.querySelector('p').classList.toggle('open');
              event.target.querySelector('.advice-arrow').classList.toggle('rotate');
              dataLayer.push(
                  {
                      'event': 'myTrackEvent', 
                      'eventCategory': 'Homepage v2', 
                      'eventAction': 'Toggle', 
                      'eventLabel': 'Advice accordion'
                  }
              );
          })
      }
  }

function noLocationInfo()
{
  document.querySelector('.home-location').innerText = 'your area';
}

function getLocation()
{
  navigator.geolocation.getCurrentPosition(
      function(position)  {
          parseLocation(position.coords.latitude, position.coords.longitude);
      },
      function(error) {
          noLocationInfo();
      }
  );
}

function parseLocation(latt, long)
{
  $.ajax({
      type: "GET",
      url: '/utilities/geo?latt=' + latt + '&long=' + long,
      success: function (result) {
          updateLocation(result);
      }
  });

}

function updateLocation(response)
{
  locationObj = JSON.parse(response);
  var city = locationObj.results[0].address_components[3].long_name;

  if (typeof city == 'undefined' || city == 'NULL')
  {
      document.querySelector('.home-location').innerText = 'your area';
  } else {
      document.querySelector('.home-location').innerText = city;

      //Set franchise finder select box to their location of possible
      var locations = document.querySelector('#location-select').options;

      for (var x = 0; x < locations.length; x++)
      {
          if (locations[x].innerText === city)
          {
              locations[x].selected = 'true';
              return;
          }
      }
  }
}